import classNames from 'classnames';

import {calculateDate} from './helper';
import {SpanIcon} from '@mazraeapp/react_icon_kit';
import CustomMessageArea from '../../../customMessageArea';
import {useState} from 'react';
import {BottomSheet} from 'react-spring-bottom-sheet';
import {useNavigate} from 'react-router-dom';
interface BuyerCardProps {
  message: string;
  isNotCallAble?: string;
  isNotSendMsg?: string;
  city: string;
  state: string;
  time?: string | null;
  cardWrapperClassName?: string;
  phone?: boolean;
  cardId?: string;
  isActiveMessage?: boolean;
  isShop?: boolean;
  isShowPhoneNumber?: boolean;
  supplierGuid?: string;
}
const BuyerCard = ({
  message,
  time,
  cardWrapperClassName,
  city,
  state,
  phone,
  cardId,
  isActiveMessage = true,
  isShop,
  supplierGuid,
}: BuyerCardProps) => {
  const [isShowReport, setIsShowReport] = useState(false);
  const navigate = useNavigate();
  return (
    <>
      <div
        className={classNames(
          'w-[296px] px-2 gap-2 flex-col bg-white flex rounded-[8px] shadow-sm relative py-2',
          cardWrapperClassName,
        )}
      >
        <div className="flex items-center justify-between">
          <p className="mb-0 font-medium text-ellipsis rounded-[8px] text-gray-950 text-sm line-clamp-1">
            {message}
          </p>
          <SpanIcon
            className="icon-nameInfo-menu-1 text-base text-gray-800"
            onClick={() => setIsShowReport(prev => !prev)}
          />
        </div>
        <div className="flex justify-between mb-3">
          <div className="flex items-center gap-1 text-gray-700 text-xs">
            <i className="icon-nameLocation text-lg" />
            <span className="">
              {city},{state}
            </span>
            <span>|</span>
            <span>{time ? calculateDate(time) : ''}</span>
          </div>
        </div>
        {isActiveMessage && (
          <div className=" flex w-full mb-2">
            <CustomMessageArea
              phoneNumber={phone}
              productId={cardId}
              size="lg"
              isShop={isShop}
              supplierGuid={supplierGuid}
            />
          </div>
        )}
      </div>
      <BottomSheet
        onDismiss={() => setIsShowReport(false)}
        open={isShowReport}
        blocking={true}
        className="custom-bottom-sheet"
      >
        <div className="flex flex-col gap-1.5 p-4">
          <SpanIcon
            className="icon-nameClose-remove text-lg text-gray-700 mr-auto"
            onClick={() => setIsShowReport(false)}
          />
          <div
            className="flex items-center gap-1 text-red-600 text-sm"
            onClick={() =>
              navigate(`/violation-report-advertisement/${cardId}`)
            }
          >
            <SpanIcon className="icon-namereport-2 text-base" />
            <span>گزارش تخلف</span>
          </div>
        </div>
      </BottomSheet>
    </>
  );
};

export default BuyerCard;
